import { useLayoutEffect, useState } from 'react';

const BREAKPOINTS = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
};

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState(() => ({
    width: window.innerWidth,
    height: window.innerHeight
  }));

  const handleSize = () => {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight
    });
  };

  useLayoutEffect(() => {
    window.addEventListener('resize', handleSize);

    return () => window.removeEventListener('resize', handleSize);
  }, []);

  return {
    ...windowSize,
    isXs: windowSize.width < BREAKPOINTS.sm,
    isSm: windowSize.width >= BREAKPOINTS.sm && windowSize.width < BREAKPOINTS.md,
    isMd: windowSize.width >= BREAKPOINTS.md && windowSize.width < BREAKPOINTS.lg,
    isLg: windowSize.width >= BREAKPOINTS.lg && windowSize.width < BREAKPOINTS.xl,
    isXl: windowSize.width >= BREAKPOINTS.xl,
    isMobileView: windowSize.width < BREAKPOINTS.lg
  };
};

export default useWindowSize;
